
import {
  Box,
  IconButton,
  Flex,
  Text,
  VStack,
  Button
} from "@chakra-ui/react";
import { IconDelete } from "components/icons/Icons";
import Popup from 'reactjs-popup';
import {useRef} from "react";

export default function DeleteButtopPopup(props: {
  displayMode: string;
  onOk: any;
}) {
  const {displayMode , onOk} = props;
  const ref = useRef<any>();
  const closeModal = () => ref.current.close();

  return (
    <Popup 
      ref={ref}
      trigger={displayMode === "desktop" ? 
        <IconButton
          aria-label="edit"
          bg="inherit"
          borderRadius="inherit"
          icon={<IconDelete width="25px" height="25px" />}
        /> : <Button
            borderRadius="0px"
            width="100%"
            padding="15px 35px"
            bgColor="#2F80ED"
            color="#FFF"
            fontSize="14px"
            lineHeight="17px"
            fontWeight="bold"
          >
            Delete
          </Button>} 
      position="top center"
      closeOnDocumentClick>
        <Box
          transition="transform 0.3s ease-in-out"
          p={4}
          border="solid 1px"
          borderColor="gray.200"
          bg="white"
          borderRadius="0.375rem"
          boxShadow='0 4px 12px rgba(0, 0, 0, 0.15)'
        >
          <VStack spacing={4}>
            <Text fontSize="lg" fontWeight="bold" color="gray.800">
              Confirmation!
            </Text>
            <Text fontSize="sm" color="gray.600">
              Are you sure to delete this project manager?
            </Text>
            <Flex direction="row" justifyContent="space-around" w="full">
              <Button
                colorScheme="teal"
                w="100px"
                onClick={onOk}
              >
                OK
              </Button>
              <Button
                variant="outline"
                colorScheme="red"
                w="100px"
                onClick={closeModal}
              >
                Cancel
              </Button>
            </Flex>
          </VStack>
        </Box>
    </Popup>
  )
}